/* eslint-disable */
let topMenuFormFixed = {
	initFormBehavior: function () {
		var $searchFormContainerWapper = $('.searchFormFliedContainer'),
			$window = $(window),
			$menuContainer = $('.menuContainer'),
			$scrollToTopArrow = $('.scrollToTop'),
			$topMenuBar = $(".topMenuBar");

		if ($searchFormContainerWapper.length) {
			$window.scroll(function (event) {
				var st = $(this).scrollTop(),
					fixPosition,
					menuHeight = $menuContainer.hasClass('stuckUp') ? $topMenuBar.height() : 0,
					$searchFormContainerWapperPosition = $searchFormContainerWapper.offset().top;

				fixPosition = $searchFormContainerWapperPosition - menuHeight - 15;

				if (st > fixPosition) {
					$searchFormContainerWapper.addClass("fixedTop");
					$scrollToTopArrow.addClass('visible');
				} else {
					$searchFormContainerWapper.removeClass("fixedTop").removeClass('minimized');
					$scrollToTopArrow.removeClass('visible');
				}
			});
		}
	},
	initFormToggle: function () {
		var $searchFormContainerWapper = $('.searchFormFliedContainer');

		$('.showToggle', $searchFormContainerWapper).on('click', function () {
			$searchFormContainerWapper.toggleClass('minimized');
		});
	},
	initialize: function () {
		this.initFormBehavior();
		this.initFormToggle();
	}
};

export default topMenuFormFixed

